module.exports = __webpack_public_path__ + "img/marker_five_red1.ca959b86.png";